import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'narwhalia-my-swarm',
  templateUrl: './my-swarm.component.html',
  styleUrls: ['./my-swarm.component.scss']
})
export class MySwarmComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
